import { MouseEventHandler } from 'react';

import { Text, TextProps } from '@mantine/core';

interface CustomTextProps extends TextProps {
  children: string | number | undefined;
  required?: boolean;
  onClick?: MouseEventHandler<HTMLParagraphElement>;
}

const CustomText = ({ children, required, ...props }: CustomTextProps) => {
  if (required) {
    return (
      <Text  {...props}>
        {children}
        <span style={{color: 'var(--mantine-color-error)'}}> *</span>
      </Text>
    );
  }
  return (
    <Text {...props}>{children}</Text>
  )
}

export default CustomText;